const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/live/$roomSlug/_protected/mobile.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_minimal/live/$roomSlug/_protected/mobile")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});